import React, { useState } from "react";
import { toast } from "react-toastify";

import { Form, Modal, InputProps, Label, Input, InputOnChangeData } from "semantic-ui-react";
import MaskedInput from "../../../components/MaskedInput";
import ModalApp from "../../../components/ModalApp";
import CalendarioRepository from "../../../Repositories/CalendarioRepository";

import errors, { IAliancaErrors } from "../../../Utils/ExtractErrors";

interface IState {
    data: string;
    titulo: string;
    horaInicio: string;
    horaFim: string;
    apiErrors: IAliancaErrors;
}

interface IProps {
    onSuccess: () => void;
}

const initialState: IState = {
    data: "",
    titulo: "",
    horaInicio: "",
    horaFim: "",
    apiErrors: { errors: [] }
}

export default function CadastrarEvento({ onSuccess }: IProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IState>(initialState);
    const [open, setOpen] = useState<boolean>(false);

    const { data, titulo, horaInicio, horaFim } = state;

    const handleSubmitForm = async () => {
        try {
            setLoading(true);

            const diaDoMes = parseInt(data.substring(0, 2));
            const dataInicio = `${data.substring(6, 10)}-${data.substring(3, 5)}-${data.substring(0, 2)}T${horaInicio}`;
            const dataFim = `${data.substring(6, 10)}-${data.substring(3, 5)}-${data.substring(0, 2)}T${horaFim}`;

            const response = await CalendarioRepository.CreateEvent({
                diaDoMes: diaDoMes,
                titulo: titulo,
                dataInicio: dataInicio,
                dataFim: dataFim
            });

            toast(`🎉 ${response.message}`, { position: "top-center", type: "success" });
            setOpen(false);
            onSuccess();

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            setState({ ...state, apiErrors: err.response.data });

            const error = errors.getApiErrors(state.apiErrors);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setLoading(false);
    }

    const handleOpen = () => {
        setState(initialState);
        setOpen(true);
    }

    const handleClose = () => { setOpen(false); }

    const hasError = (key: string) => {
        return errors.hasError(state.apiErrors, key);
    }

    const getMessage = (key: string) => {
        return errors.getMessage(state.apiErrors, key);
    }

    function handleOnChange(event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) {
        setState(state => ({ ...state, [data.name]: data.value }));
    }

    const cadastrarContent = (
        <Modal.Content scrolling>
            {!loading &&
                <Form>
                    <Form.Field error={hasError("Titulo")} required>
                        <label>Titulo</label>
                        <Input
                            name="titulo"
                            placeholder="Titulo"
                            value={titulo}
                            onChange={handleOnChange}
                            autoFocus
                        />
                        {hasError("Titulo") && <Label pointing prompt>{getMessage("Titulo")}</Label>}
                    </Form.Field>
                    <Form.Field error={hasError("Data")} required>
                        <label>Data</label>
                        <MaskedInput
                            fluid
                            mask="data"
                            name="data"
                            placeholder="Data do evento"
                            value={data}
                            onChange={handleOnChange}
                        />
                        {hasError("Data") && <Label pointing prompt>{getMessage("Data")}</Label>}
                    </Form.Field>
                    <Form.Field error={hasError("HoraInicio")} required>
                        <label>Hora inicial</label>
                        <MaskedInput
                            fluid
                            mask="hora"
                            name="horaInicio"
                            placeholder="hora inicial"
                            value={horaInicio}
                            onChange={handleOnChange}
                        />
                        {hasError("HoraInicio") && <Label pointing prompt>{getMessage("HoraInicio")}</Label>}
                    </Form.Field>
                    <Form.Field error={hasError("HoraFinal")} required>
                        <label>Hora final</label>
                        <MaskedInput
                            fluid
                            mask="hora"
                            name="horaFim"
                            placeholder="hora final"
                            value={horaFim}
                            onChange={handleOnChange}
                        />
                        {hasError("HoraFinal") && <Label pointing prompt>{getMessage("HoraFinal")}</Label>}
                    </Form.Field>
                </Form>}
        </Modal.Content>
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Cadastrar"
            content={cadastrarContent}
            loading={loading}
            trigger={{
                icon: "add",
                color: "pink",
                content: "Novo",
                labelPosition: "left",
                floated: "right"
            }}
            onSuccess={{ content: "Salvar", func: handleSubmitForm }}
        />
    );
}
